import { forwardRef } from "react";
import { LandscapeCourtSvg } from "../../match/court/components/CourtSvgs";
import { LandscapePickleballCourtSvg } from "../../../sports/pickleball/assets/PickleballCourtSvgs";
import { LandscapeTennisCourtSvg } from "../../../sports/tennis/assets/TennisCourtSvgs";
import { LandscapeTableTennisSvg } from "../../../sports/table-tennis/assets/TableTennisCourtSvgs";
import { SPORT_IDS } from "../../../domain/sport/sportTypes";
import { useActiveSport } from "../../../sports/ActiveSportContext";
import styles from "../styles/playerExperience.module.css";

function CourtArt({ sportId }) {
  if (sportId === SPORT_IDS.PICKLEBALL) return <LandscapePickleballCourtSvg />;
  if (sportId === SPORT_IDS.TENNIS) return <LandscapeTennisCourtSvg />;
  if (sportId === SPORT_IDS.TABLE_TENNIS) return <LandscapeTableTennisSvg />;
  return <LandscapeCourtSvg />;
}

/**
 * Home primary CTA — same create-panel action as Start Casual Arena, drawn as the active-sport court.
 */
const HomeStartQuickMatchCourt = forwardRef(function HomeStartQuickMatchCourt(
  { expanded = false, onClick },
  ref
) {
  const { sportId } = useActiveSport();
  return (
    <button
      ref={ref}
      type="button"
      className={`${styles.quickCourt}${expanded ? ` ${styles.quickCourtOn}` : ""}`}
      data-testid="home-create-arena"
      data-sport={sportId}
      aria-expanded={expanded}
      aria-controls="home-create-join"
      aria-label="Start Quick Match"
      onClick={onClick}
    >
      <span className={styles.quickCourtArt} aria-hidden>
        <CourtArt sportId={sportId} />
      </span>
      <span className={styles.quickCourtLabel}>Start Quick Match</span>
    </button>
  );
});

export default HomeStartQuickMatchCourt;
